import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImplantationOrderPopupComponent } from 'src/app/chart-popup/implantation-order-popup/implantation-order-popup.component';
import { ResponseData } from 'src/app/service/model/response.model';

@Component({
  selector: 'app-implantation-order-yearly',
  templateUrl: './implantation-order-yearly.component.html',
  styleUrls: ['./implantation-order-yearly.component.scss']
})
export class ImplantationOrderYearlyComponent {


  @Input() item!: ResponseData;
  currentYear = new Date("YYYY");
  
  // public barChartOptions: any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };

    public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 10,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

  chartData: number[] = [];
  public barChartLabels: string[] = []
  public barChartData: any[] = [];

  public barChartType: string = 'bar';
  //public barChartLegend:boolean = true;

  public barChartColors: Array<any> = [
    {
      backgroundColor: '#358785',
      borderColor: '#29524fff',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    }
  ];
  constructor(private modalService: NgbModal) { }

  ngAfterViewInit() {
    this.CreateChart();
  }

  CreateChart() {
    for (let i = 0; i < this.item.data.dashboardImplantationOrdersChart.length; i++) {
      //console.log(this.item.data.dashboardImplantationOrdersChart[i]);
      this.barChartLabels.push(this.item.data.dashboardImplantationOrdersChart[i].implementationName)
      this.chartData.push(this.item.data.dashboardImplantationOrdersChart[i].orderCount)
    }

    this.barChartData = [{ data: this.chartData, label: (new Date()).getFullYear() }];

  }

  OpenPopUp() {


    const modalRef = this.modalService.open(ImplantationOrderPopupComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    (modalRef.componentInstance as ImplantationOrderPopupComponent).defaultChartData = this.item.data.dashboardImplantationOrdersChart;

    modalRef.result.then((result) => {
      console.log(result);


    });

  }



  // events
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }


}
